import { Action, createReducer, on } from '@ngrx/store';
import { ApiProgram } from '@app/programs/views/models/api-program';
import { loadProgram, loadProgramFailure, loadProgramSuccess } from '@app/core/store/programs/actions';
import { ProgramError } from '@app/programs/views/services/programs-api-http.service';

export interface ProgramsState {
  program: ApiProgram | null;
  error: ProgramError | null;
}

export const initialState: ProgramsState = {
  program: null,
  error: null,
};

export const reducers = createReducer(initialState,
  on(loadProgram,
    (state: ProgramsState): ProgramsState => ({
      ...state,
      error: null,
    }),
  ),
  on(loadProgramSuccess,
    (state: ProgramsState, { program }): ProgramsState => ({
      ...state,
      program: { ...program },
    }),
  ),
  on(loadProgramFailure,
    (state: ProgramsState, { error }): ProgramsState => ({
      ...state,
      error,
    }),
  ),
);

export function programsReducer(state: ProgramsState, action: Action): ProgramsState {
  return reducers(state, action);
}
